import React from 'react';
import { Edit2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './Button';
import { useUser } from '../contexts/UserContext';
import { useAuth } from '../contexts/AuthContext';
export function ProfileHeader() {
  const {
    user
  } = useAuth();
  const {
    stats
  } = useUser();
  return <div className="flex flex-col items-center text-center space-y-4" data-id="element-446">
      <div className="relative" data-id="element-447">
        <img src={user?.photoURL || `https://api.dicebear.com/7.x/avataaars/svg?seed=${user?.uid}`} alt={user?.displayName || 'User'} className="w-32 h-32 rounded-full border-4 border-white dark:border-gray-800 shadow-lg" data-id="element-448" />
        <div className="absolute -bottom-2 -right-2 bg-game-yellow text-game-dark font-bold px-3 py-1 rounded-full border-2 border-white shadow-sm text-sm" data-id="element-449">
          Lvl {stats.level}
        </div>
      </div>

      <div data-id="element-450">
        <h2 className="text-2xl font-fredoka font-bold text-game-dark dark:text-white" data-id="element-451">
          {user?.displayName || 'QuestZen User'}
        </h2>
        <p className="text-gray-500 dark:text-gray-400 font-quicksand" data-id="element-452">
          Productivity Wizard • {stats.xp} XP
        </p>
      </div>

      <Link to="/edit-profile" data-id="element-453">
        <Button variant="secondary" size="sm" icon={<Edit2 className="w-4 h-4" data-id="element-455" />} data-id="element-454">
          Edit Profile
        </Button>
      </Link>
    </div>;
}